import { WhatsAppMsgTypeEnum, WhatsappPriorityEnum } from "../enums";


export class WhatsAppBroadCastRequest{
    companyId: number;
    priority: WhatsappPriorityEnum;
	messageType: WhatsAppMsgTypeEnum;
    message: string;
    contacts: string[];
    image ?:string;
}  